import { useState } from "react";
import { Link } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeft, LifeBuoy, Loader2, MailCheck } from "lucide-react";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center p-8">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2 mb-8">
          <LifeBuoy className="h-6 w-6 text-indigo-400" />
          <span data-testid="brand-text" className="font-semibold text-lg text-zinc-100">Help Desk</span>
        </div>
        {sent ? (
          <div data-testid="forgot-success">
            <div className="h-12 w-12 rounded-full bg-emerald-400/10 flex items-center justify-center mb-4">
              <MailCheck className="h-5 w-5 text-emerald-400" />
            </div>
            <h2 className="text-xl tracking-tight font-medium text-zinc-100 mb-2">Verifique seu e-mail</h2>
            <p className="text-sm text-zinc-400 mb-6">Se o e-mail estiver cadastrado, enviamos um link para redefinir sua senha (válido por 1 hora).</p>
            <Link to="/login" className="text-sm text-indigo-400 hover:text-indigo-300">Voltar ao login</Link>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="forgot-form">
            <h2 className="text-xl tracking-tight font-medium text-zinc-100 mb-1">Recuperar senha</h2>
            <p className="text-sm text-zinc-400 mb-6">Informe seu e-mail para receber o link de redefinição.</p>
            {error && <div data-testid="forgot-error" className="text-rose-400 bg-rose-400/10 text-sm rounded-md px-3 py-2 mb-4">{error}</div>}
            <Label htmlFor="email" className="text-xs text-zinc-400">E-mail</Label>
            <Input id="email" data-testid="forgot-email-input" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} placeholder="voce@empresa.com.br"
              className="mt-1.5 mb-4 bg-zinc-950 border-zinc-800 text-zinc-100 placeholder:text-zinc-500 rounded-md focus:border-indigo-500" />
            <Button data-testid="forgot-submit-button" type="submit" disabled={loading}
              className="w-full bg-indigo-600 hover:bg-indigo-500 text-white rounded-md transition-colors duration-200">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Enviar link de redefinição"}
            </Button>
            <div className="text-center mt-4">
              <Link to="/login" className="inline-flex items-center gap-1 text-xs text-zinc-400 hover:text-indigo-400 transition-colors duration-200">
                <ArrowLeft className="h-3 w-3" /> Voltar ao login
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
